<form class="filter-bar" [formGroup]="form" aria-label="Filtros de adesão">
  <div class="row g-3">
    <div class="col-12 col-md-4">
      <label class="filter-label" for="filtro-adesao-nome">Procure por nome</label>
      <input
        id="filtro-adesao-nome"
        type="search"
        class="form-control filter-control"
        formControlName="nome"
        placeholder="Digite o nome do participante"
        autocomplete="off"
        data-testid="filtro-adesao-nome"
      />
    </div>

    <div class="col-12 col-md-3">
      <label class="filter-label" for="filtro-adesao-status">Status</label>
      <select
        id="filtro-adesao-status"
        class="form-select filter-control"
        formControlName="status"
        data-testid="filtro-adesao-status"
      >
        @for (option of statusOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
        }
      </select>
    </div>

    <div class="col-12 col-md-5">
      <label class="filter-label" for="filtro-adesao-data">Última atualização</label>
      <input
        id="filtro-adesao-data"
        type="date"
        class="form-control filter-control"
        formControlName="data"
        [min]="periodoDe()"
        [max]="periodoAte()"
        data-testid="filtro-adesao-data"
      />
    </div>
  </div>
</form>
